interface IDateConfigParams {
  language?: string;
}

const DEFAULT_LANGUAGE = 'en-US';

const config: IDateConfigParams = {
  language: DEFAULT_LANGUAGE,
};

export const configure = ({ language }: IDateConfigParams): void => {
  if (language) {
    config.language = language;
  }
};

export default config;
